import { axiosInstance } from './ApiConfig';

export async function GetLaunch({ config_id }) {
  const response = await axiosInstance({
    method: 'GET',
    url: `/launch/${config_id}`,
  });

  if (response.status === 200) {
    return response.data.value;
  } else {
    throw new Error('Failed to get launch string');
  }
}
